module.exports = __webpack_public_path__ + "img/category_ktrack.e8d8308e.jpg";